import React from 'react';
import PropTypes from 'prop-types';
import styles from './Layout.module.scss';

Layout.propTypes = {
  Header: PropTypes.func.isRequired,
  Footer: PropTypes.func.isRequired,
  pages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  children: PropTypes.node.isRequired,
};

export default function Layout({ Header, Footer, pages, children }) {
  return (
    <div className={styles.root}>
      <Header pages={pages} />
      <div className={styles.body}>
        {children}
      </div>
      <Footer pages={pages} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Layout.js